export default __webpack_public_path__ + "resources/icons/d310-9823.png";